import type { CSSProperties } from 'react';

import { Box } from '@opendoor/atoms/box';
import { Image } from '@opendoor/atoms/image';
import { cn } from '@opendoor/atoms/utils';
import { buildFloorPlanSrc } from 'components/marketplace/helpers/galleryPhotos';
import type { GalleryPhoto } from 'components/marketplace/helpers/galleryPhotos';
import {
  type GalleryBreakpointTier,
  generateGalleryPictureSet,
} from 'components/marketplace/helpers/presizedPhotos';

export type GalleryListingPhotoProps = {
  photo: GalleryPhoto;
  sizes: GalleryBreakpointTier[];
  alt: string;
  lazy?: boolean;
  preload?: boolean;
  fetchPriority?: 'high' | 'low' | 'auto';
  objectFit?: CSSProperties['objectFit'];
  className?: string;
};

export const GalleryListingPhoto = ({
  photo,
  sizes,
  alt,
  lazy = true,
  preload = false,
  fetchPriority,
  objectFit = 'cover',
  className,
}: GalleryListingPhotoProps) => {
  if (photo.isFloorPlan) {
    const fitClass = objectFit === 'contain' ? 'object-contain' : 'object-cover';
    return (
      <Image
        src={buildFloorPlanSrc(photo.url)}
        alt={alt}
        loading={lazy ? 'lazy' : 'eager'}
        fetchPriority={fetchPriority}
        className={cn('block h-full w-full', fitClass, className)}
      />
    );
  }

  return (
    <Box className={cn('h-full w-full', className)}>
      {generateGalleryPictureSet({
        debugImageSizes: false,
        photo,
        sizes,
        lazy,
        preload,
        fetchPriority,
        alt,
        objectFit,
      })}
    </Box>
  );
};
